


























import { Component, Prop, Vue, Watch, Emit } from 'vue-property-decorator';

type Size = 'small' | 'medium' | 'large';

interface InputConfig {
  name?: string,
  type?: string,
  size?: Size,
  disabled?: boolean,
  placeholder?: string,
  readonly?: boolean,
  clearable?: boolean,
  maxlength?: number,
  minlength?: number,
  label?: string,
  key?: string,
  inline?: boolean,
  tip?: string,
  validators?: any,
  prepend?: string,
  append?: string,
  suffix?: string,
  suffixIcon?: string,
  handleSuffix?: Function
}

@Component({
  name: 'mcInput'
})
export default class extends Vue {
  @Prop({ default: () => [] }) private value!: string | undefined;
  @Prop({ default: () => [] }) private config!: InputConfig;
  @Prop() private extension?: (value: any) => void;
  private currentValue: string = this.value;
  private defaultConfig: any = {
    size: 'medium',
    placeholder: '请输入'
  };

  // 检测值
  @Watch("value")
  onValueChanged(val: string) {
    this.currentValue = val;
  }

  // 合并默认数据
  get currentConfig() {
    const result = this.config;
    Object.keys(this.defaultConfig).forEach((key: string) => {
      if (this.config[key] === undefined) result[key] = this.defaultConfig[key];
    });
    return result;
  }

  mounted() {
    this.extension && this.extension({
      setValue: (value: string) => this.$emit('input', value)
    });
  }

  /**
   * 输入框值改变
   * @author tanxj
   * @param value 值
   */
  @Emit('on-change')
  handleChange(value: string) {
    this.$emit('input', value);
  }

  /**
   * 失去焦点事件
   * @author tanxj
   * @param any event 事件
   */
  handleBlur(event: any) {
    this.$emit('on-blur', event.target.value, event);
  }

  /**
   * 使input 获取焦点
   * @author tanxj
   * @param any event 事件
   */
  handleFocus(event: any) {
    this.$emit('on-focus', event);
  }

  /**
   * 操作事件
   * @author tanxj
   */
  handleSuffix() {
    this.config.handleSuffix && this.config.handleSuffix();
  }
}
